import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function Markdown({ children }: { children: string }) {
  return (
    <div className="kb-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD_COMPONENTS}>
        {children}
      </ReactMarkdown>
    </div>
  );
}

const MD_COMPONENTS: Components = {
  p: ({ children }) => <p className="kb-md__p">{children}</p>,
  strong: ({ children }) => <strong className="kb-md__strong">{children}</strong>,
  em: ({ children }) => <em className="kb-md__em">{children}</em>,
  del: ({ children }) => <del className="kb-md__del">{children}</del>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="kb-md__a">
      {children}
    </a>
  ),
  ul: ({ children }) => <ul className="kb-md__ul">{children}</ul>,
  ol: ({ children }) => <ol className="kb-md__ol">{children}</ol>,
  li: ({ children }) => <li className="kb-md__li">{children}</li>,
  h1: ({ children }) => <h2 className="kb-md__h1">{children}</h2>,
  h2: ({ children }) => <h3 className="kb-md__h2">{children}</h3>,
  h3: ({ children }) => <h4 className="kb-md__h3">{children}</h4>,
  code: ({ className, children }) => {
    // Detect block fences without a language: react-markdown calls this for
    // both inline (`code`) and block (```code```) — language- only catches
    // ```js fences. Any newline in children means it's a block (inline code
    // can't span lines), so check both signals.
    const text = String(children ?? '');
    const isBlock = /language-/.test(className ?? '') || text.includes('\n');
    if (isBlock) {
      return (
        <code className={`${className ?? ''} kb-md__code-block`}>{children}</code>
      );
    }
    return <code className="kb-md__code-inline">{children}</code>;
  },
  pre: ({ children }) => <pre className="kb-md__pre">{children}</pre>,
  blockquote: ({ children }) => <blockquote className="kb-md__quote">{children}</blockquote>,
  hr: () => <hr className="kb-md__hr" />,
  table: ({ children }) => (
    <div className="kb-md__table-wrap">
      <table className="kb-md__table">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="kb-md__thead">{children}</thead>,
  th: ({ children }) => <th className="kb-md__th">{children}</th>,
  td: ({ children }) => <td className="kb-md__td">{children}</td>,
};
